import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appsAppGroupIdUserImportsImportIdScanEventNames } from "./constants";
import type { GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult } from "./types";
import { isGetAppsAppGroupIdUserImportsImportIdScanEventNamesResult } from "./validators";

export const getAppsAppGroupIdUserImportsImportIdScanEventNames = reactQueryFetcherAdapter(
  appsAppGroupIdUserImportsImportIdScanEventNames,
  (
    signal: AbortSignal,
    appGroupId: string,
    importId: string,
    nameSourceIndex: number
  ): Promise<GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult> => {
    if (!Number.isInteger(nameSourceIndex) || nameSourceIndex < 0) {
      return Promise.reject(new Error("scan_event_names requires a non-negative integer name_source_index"));
    }

    return fetch<GetAppsAppGroupIdUserImportsImportIdScanEventNamesResult>(
      `/apps/${appGroupId}/user_imports/${importId}/scan_event_names`,
      "GET",
      { name_source_index: String(nameSourceIndex) },
      { signal }
    );
  },
  isGetAppsAppGroupIdUserImportsImportIdScanEventNamesResult
);
